/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Severityworkday2Inputs */

const en_severityworkday2 = /** @type {(inputs: Severityworkday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work`)
};

const pt_severityworkday2 = /** @type {(inputs: Severityworkday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalho`)
};

/**
* | output |
* | --- |
* | "Work" |
*
* @param {Severityworkday2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const severityworkday2 = /** @type {((inputs?: Severityworkday2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Severityworkday2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_severityworkday2(inputs)
	return pt_severityworkday2(inputs)
});
export { severityworkday2 as "severityWorkDay" }